import { MotifDivider } from "../components/Motif";

const GUIDES = [
  {
    id: "communion",
    eyebrow: "Sacrament Guide",
    title: "First Holy Communion",
    image: "https://images.pexels.com/photos/3775147/pexels-photo-3775147.jpeg",
    body: [
      "The first reception of the Eucharist deserves keepsakes that will outlast the day. A white rosary, a missal embossed with the child's name, and a slim silver cross are the quiet anchors.",
      "Pair them with a sanctuary candle and a small statue of the Sacred Heart for the prayer corner — gifts that travel from the chapel to the bedside table.",
      "Our boxed Communion hampers come with rosary, prayer book and an ivory candle, finished with a hand-tied ribbon and a blessing card.",
    ],
  },
  {
    id: "baptism",
    eyebrow: "Sacrament Guide",
    title: "Baptism Welcome",
    image: "https://images.pexels.com/photos/599268/pexels-photo-599268.jpeg",
    body: [
      "The font, the white garment, the lit candle — Baptism is a ceremony of small tender objects. Choose a christening candle that the family will relight on each baptismal anniversary.",
      "A baby crucifix for above the cot, a soft-lamb plush, and a leather-bound New Testament make a complete welcome — for both child and godparents.",
      "We curate Baptism hampers in white and ivory, finished with the child's initials on request.",
    ],
  },
  {
    id: "christmas",
    eyebrow: "Festive Guide",
    title: "The Christmas Edit",
    image: "https://images.pexels.com/photos/3775140/pexels-photo-3775140.jpeg",
    body: [
      "Begin Advent with a wreath of four candles — three violet, one rose. Light one each Sunday as the season unfolds.",
      "An olive wood nativity from the Holy Land sits beautifully at the centre of the home — a quiet reminder of the manger through December.",
      "Round out the season with frankincense and myrrh resin for the censer, and a sterling silver cross pendant gift for a loved one.",
    ],
  },
  {
    id: "wedding",
    eyebrow: "Sacrament Guide",
    title: "Catholic Wedding Blessing",
    image: "https://images.pexels.com/photos/3772415/pexels-photo-3772415.jpeg",
    body: [
      "His-and-hers rosaries, a unity candle, and an embossed Holy Bible — the trinity of a Catholic wedding gift. We engrave names and the wedding date on request.",
      "For the home altar, gift the couple a Madonna and Child statue and a pair of beeswax altar tapers — a foundation for prayer in the new household.",
    ],
  },
];

export default function Guides() {
  return (
    <div className="fade-up">
      <section className="px-6 md:px-12 lg:px-20 pt-16 md:pt-24 pb-8 text-center">
        <span className="eyebrow">Sacrament &amp; Gift Guides</span>
        <h1 className="font-serif-display text-5xl md:text-6xl mt-3 max-w-3xl mx-auto leading-tight">
          The objects, and the moments that hold them.
        </h1>
        <p className="mt-5 text-[var(--srishti-text-secondary)] max-w-xl mx-auto">
          A small library of journals from our boutique — read before you choose.
        </p>
      </section>

      <div className="max-w-2xl mx-auto px-6"><MotifDivider /></div>

      <div className="px-6 md:px-12 lg:px-20 pb-24 space-y-20">
        {GUIDES.map((g, i) => (
          <article
            key={g.id}
            id={g.id}
            className={`max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center ${
              i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
            }`}
            data-testid={`guide-${g.id}`}
          >
            <div className="md:col-span-7 image-zoom aspect-[4/3]">
              <img src={g.image} alt={g.title} className="w-full h-full object-cover" />
            </div>
            <div className="md:col-span-5">
              <span className="eyebrow">{g.eyebrow}</span>
              <h2 className="font-serif-display text-4xl md:text-5xl mt-2 leading-tight">
                {g.title}
              </h2>
              <div className="mt-5 space-y-4 text-[var(--srishti-text-secondary)] leading-relaxed">
                {g.body.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
